import urls from '../api_urls/topManagement'
import { _post } from '@/axios/request'

// 获取product列表
export function getProductData (params) {
  // return _post(urls.GET_PRODUCT_LIST, params)
  let arr = Array.from({ length: 10 }).map((v, i) => {
    return {
      name: `product-name${i}`,
      group: 'Kao',
      brand: 'Kao',
      price: 'JPY 686.00 / $6.06 / €5.11',
      description: 'Product description: To those worried about “pore dirt”. Ado pted “Clear Rectangle Cup…',
      inci: 'water, mannitol, arginine, trehalose, tromethamine, sorbitol, acrylates/C1…',
      picture: '******.jpg'
    }
  })
  return arr
}

// 获取source列表
export function getSourceData (params) {
  // return _post(urls.GET_SOURCE_LIST, params)
  let arr = Array.from({ length: 10 }).map((v, i) => {
    return {
      title: '@Cosme'
    }
  })
  return arr
}



// WEBPACK FOOTER //
// ./src/axios/api/topManagement.js